import React, { useCallback, useEffect, useState } from "react";
import styles from "./Tabs.module.scss";
import classNames from "classnames";
import { useAppDispatch, useAppSelector } from "utils/store";
import { NavigationActions } from "core/navigation/navigation.slice";

export type TabItem = {
  name: string;
  id: string;
};
type Props = {
  tabs: TabItem[];
  onChangeTab: (tab: TabItem) => void;
  selectedTab: TabItem;
};
export const Tabs: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <div className={styles.Container}>
      <div className={styles.ItemsWrapper}>
        {props.tabs.map((tab) => (
          <div
            key={tab.id}
            data-testid={tab.name}
            onClick={() => props.onChangeTab(tab)}
            className={classNames(styles.Item, {
              [styles.selected]: props.selectedTab.name === tab.name,
            })}
          >
            {tab.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export const useTabs = (tabs: TabItem[], defaultTabIndex = 0, key: string) => {
  const tabState = useAppSelector((state) => state.navigation.tabs);
  const dispatch = useAppDispatch();
  const [selectedTab, setSelectedTab] = useState<TabItem>(
    tabs.find((i) => i.id === tabState[key]) || tabs[defaultTabIndex]
  );

  useEffect(() => {
    dispatch(
      NavigationActions.setTabState({ key: key, value: selectedTab.id })
    );
  }, [selectedTab]);

  const onChangeTab = useCallback((tab: any) => {
    setSelectedTab(tab);
  }, []);

  return { tabs, selectedTab, onChangeTab };
};
